import { Control } from 'ol/control';
import { getWMS } from './layers';
import { getLayerById } from './layer-tools';
import { map } from './tools';

const panel = document.getElementById('wmsPanelContent');

export class WizardSwitch extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = 'Kalkulator';

    const element = document.createElement('div');
    element.id = 'wizardSwitch';
    element.className = 'switch ol-unselectable ol-control';
    element.title = 'Vise/Skjule kalkulator';
    element.appendChild(button);

    super({ element: element, target: options.target });

    button.addEventListener('click', this.toggle.bind(this), false);
  };

  toggle = () => {
    const w = document.getElementById('wizard');
    const isHidden = (w.style.display === 'none');
    w.style.display = isHidden ? 'block' : 'none';
  };
}

export const newSwitch = (id, txt, fs, options) => {
  const fieldset = document.getElementById(fs);
  // Map not ready, we are defining a switch while creating the map.
  // const l = getLayerById(id);
  const wms = getWMS(id);
  class Switch extends Control {
    constructor(opt_options) {
      const options = opt_options || {};

      const element = document.createElement('li');
      element.id = `${id}Switch`;
      element.className = 'wms-item';
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.id = `${id}Checkbox`;
      cb.title = `Slå av/på ${txt}`;
      cb.checked = (id === 'grunnkart') ? true : false;
      cb.onchange = () => {
        const l = wms || getLayerById(id); // wmts flybilder
        const nib = l.get('id') === 'flybilder';
        if (nib) map.getLayers().item(0).setVisible(!cb.checked);
        l.setVisible(cb.checked);
        // Do not wait for previous base map tiles to be loaded:
        if (cb.checked) map.tileQueue_.tilesLoading_ = 0;
        const legend = document.getElementById(`${id}Legend`);
        if (legend) legend.hidden = !cb.checked;
      };
      const label = document.createElement('label');
      label.htmlFor = cb.id;
      label.innerHTML = txt;
      element.appendChild(cb);
      element.appendChild(label);
      if (wms) { // (id !== 'flybilder') {
      const slider = document.createElement('input');
        slider.type = 'range';
        slider.id = `${id}Slider`;
        slider.value = wms.getOpacity() * 100;
        slider.oninput = () => {
          const l = wms || getLayerById(id); // wmts flybilder
          l.setOpacity(slider.value / 100);
        }
        element.appendChild(slider);
      }

      super({ element: element, target: options.target || fieldset || panel });
    };

  }
  return new Switch(options);
};

